import request from "graphql-request"
import { homepageQuery } from "../graphql/homepage";
const endpoint = process.env.REACT_APP_SANITY_URL;

if (endpoint === undefined) throw new Error("undefined env variable -> sanity url")

const getHomepage = async () => {
  const { Homepage } = await request(endpoint, homepageQuery);
  return Homepage;
}

export {
  getHomepage
}